const hr = {
  common: {
    loading: "Učitavanje...",
    close: "Zatvoriti",
    submit: "Pošalji",
    review: "Pregled",
    help: "Pomoć",
    tour: "obilazak",
    instructions: "upute",
    language: "Jezik",
    ok: "U redu",
    appLoaderText:
      "Učitavanje... Molimo pričekajte dok pripremamo vaše okruženje za procjenu."
  },
  assessment: {
    fetchError: "Pogreška pri dohvaćanju {{featureName}}",
    somethingWentWrong: "Nešto nije u redu.",
    goBackToDashboard: "Vratite se na nadzornu ploču",
    confirmSubmissionTitle: "Potvrdite predaju",
    scheduleIdNotFound: "ID rasporeda nije pronađen",
    ongoingIdNotFound: "Id u tijeku nije pronađen",
    errorFetchingOngoingData: "Pogreška pri dohvaćanju podataka u tijeku",
    connectionRestoredLabel: "Veza je uspostavljena.",
    connectionRestoredDescription:
      "Možete nastaviti s pokretanjem testnih slučajeva.",
    connectionLostLabel: "Izgubili smo vezu s testnim poslužiteljem.",
    connectionLostDescription:
      "Trenutačno nećete moći pokrenuti ili potvrditi testne slučajeve.",
    featureNames: {
      assessment: "Procjena",
      knowledgeCheck: "Provjera znanja"
    },
    cardStatus: {
      na: "N/A",
      toBeLaunched: "Tek treba biti pokrenuto",
      expired: "Isteklo",
      expiringSoon: "Uskoro istječe",
      ongoing: "U tijeku"
    },
    cardState: {
      draft: "Skica",
      published: "Objavljeno",
      cancelled: "Otkazano",
      inreview: "U pregledu",
      readytopublish: "Spremno za objavu",
      sentback: "Vraćeno"
    },
    dashboard: {
      videoProctoring: "Video Proctoring",
      submitFeature: "Pošalji {{featureName}}",
      noSectionsFound: "Nije pronađen nijedan odjeljak",
      expandAllSections: "Proširite sve odjeljke",
      closeAllSections: "Zatvorite sve odjeljke",
      continueShapingAssessments: "Nastavite oblikovati svoje procjene",
      viewAll: "Prikaži sve",
      legend: {
        notStarted: "Nije započeto",
        inProgress: "U tijeku",
        completed: "Završeno"
      }
    },
    confirmModal: {
      description:
        "Nakon slanja, nećete moći napraviti nikakve promjene na svom {{featureName}}. Pregledajte svoje odgovore prije potvrde. Želite li nastaviti s podnošenjem?",
      lowWordCountWarning:
        "Vaš odgovor na pitanje, {{questionTitle}} kraći je od 40 riječi. Ako sada pošaljete procjenu, ovaj odgovor neće biti spremljen.",
      videoNotSubmittedWarning:
        "Vaš snimljeni video za pitanje, {{questionTitle}} nije poslan. Slanje procjene sada će odbaciti ovaj odgovor.",
      unansweredQuestions: "Imate {{count}} pitanja bez odgovora",
      andFlaggedQuestions: "i {{count}} označenih pitanja",
      failedToFinish: "Nije uspjelo završiti {{featureName}}"
    },
    feedback: {
      submittedTitle: "Vaša {{featureName}} je uspješno poslana!",
      submittedDescription:
        "Vaši odgovori su predani. Cijenimo vrijeme i trud koji ste uložili u dovršavanje ove {{featureName}}!",
      resultInProgress:
        "Rezultat se izračunava i može potrajati do jedne minute. Molimo pričekajte...",
      resultReady:
        "Rezultat je spreman! Kliknite gumb Prikaži rezultat da biste ga vidjeli.",
      resultDelayed:
        "Izračun rezultata traje više vremena nego inače. Molimo kontaktirajte administratora za svoj rezultat.",
      showResult: "Prikaži rezultat",
      redirectingToResult:
        "Preusmjeravanje na stranicu s rezultatima za {{seconds}} sekundi ako ne kliknete gumb Prikaži rezultate",
      shareFeedbackTitle: "Podijelite svoje povratne informacije",
      shareFeedbackDescription:
        "Vaši uvidi utiru put rastu. Pređimo na razinu zajedno!",
      errorSubmittingFeedback: "Pogreška pri slanju povratnih informacija",
      feedbackSubmittedTitle: "Sve spremno, povratne informacije su poslane!",
      feedbackSubmittedDescription:
        "Vaše povratne informacije su poslane. Hvala vam što nam pomažete poboljšati iskustvo {{featureName}}!",
      feedbackAlreadySubmittedTitle:
        "Sve spremno, povratne informacije su već poslane!",
      feedbackAlreadySubmittedDescription:
        "Čini se da ste već poslali povratne informacije. Hvala vam što nam pomažete poboljšati iskustvo {{featureName}}!"
    },
    page: {
      errorFetchingPreAssessmentData:
        "Pogreška pri dohvaćanju podataka prethodne procjene",
      connectionRestoredLabel: "Veza je uspostavljena.",
      connectionRestoredDescription:
        "Sinkronizacija vaših najnovijih promjena...",
      offlineLabel: "Čini se da ste izvan mreže.",
      offlineDescription:
        "Promjene se neće sinkronizirati dok se ponovno ne povežete"
    },
    question: {
      questions: "Pitanja",
      closeQuestionsPanel: "Zatvori ploču s pitanjima",
      collapse: "Kolaps",
      sectionSummary: "Sažetak odjeljka",
      sections: "Sekcije",
      toggleQuestionsPanel: "Uključi/isključi ploču s pitanjima",
      switchModal: {
        switchQuestionButton: "Prebaci pitanje",
        leaveHeading: "Jeste li sigurni da želite otići?",
        discardMessage:
          "Imate nespremljene promjene. Ako promijenite pitanje, vaš će odgovor biti trajno izbrisan.",
        saveChangesButton: "Spremi promjene",
        saveHeading: "Želite li spremiti promjene?",
        saveBeforeSwitchMessage:
          "Imate nespremljene promjene. Želite li ih spremiti prije promjene pitanja?"
      }
    },
    faq: {
      q1: {
        question: "Što trebam učiniti prije pokretanja {{featureName}}?",
        firstSentence: "Provjerite jeste li dovršili sljedeće:",
        list: {
          item1: "Stabilna internetska veza",
          item2:
            "Ispravna web-kamera i mikrofon (ako je omogućen videoproctoring)",
          item3: "Mirno okruženje bez ometanja",
          item4:
            "Ako je videoproctoring omogućen, od vas će se tražiti da dovršite provjeru sustava.",
          item5: "Pročitajte i prihvatite Uvjete i odredbe"
        }
      },
      q2: {
        question:
          "Mogu li se kretati između pitanja ili odjeljaka tijekom {{featureName}}?",
        firstSentence: "Navigacija ovisi o postavkama.",
        list: {
          item1:
            "Ako je navigacija odjeljcima omogućena, možete se kretati između odjeljaka.",
          item2:
            "Ako je onemogućeno, morat ćete dovršiti jedan odjeljak prije prelaska na sljedeći."
        },
        lastSentence:
          "Upute će biti dostupne cijelo vrijeme tijekom {{featureName}}."
      },
      q3: {
        question: "Hoću li biti pod nadzorom tijekom testa?",
        list: {
          item1:
            "Ako ovaj {{featureName}} ima omogućen videoproctoring, koristit će se vaša kamera i mikrofon.",
          item2: "Svaka neobična aktivnost može biti označena za pregled."
        }
      },
      q4: {
        question:
          "Što se događa ako izgubim internetsku vezu ili slučajno zatvorim preglednik?",
        firstSentence: "Vaš napredak se automatski sprema.",
        lastSentence:
          "Ako dođe do prekida veze, možete se ponovno pridružiti {{featureName}} pomoću iste veze."
      },
      q5: {
        question:
          "Hoću li vidjeti svoje rezultate ili povratne informacije nakon testa?",
        firstSentence:
          "Rezultate i povratne informacije konfigurira organizator {{featureName}}.",
        list: {
          item1:
            "Ako je omogućeno, vidjet ćete svoj rezultat i sažetak povratnih informacija nakon slanja.",
          item2:
            "Ako ne, vaši rezultati će biti podijeljeni putem vaše registrirane e-pošte."
        }
      }
    },
    labels: {
      totalDuration: "Ukupno trajanje",
      numberOfQuestions: "Broj pitanja",
      numberOfSections: "Broj odjeljaka",
      guidelines: "Smjernice",
      platformHelp: "Pomoć za platformu",
      faq: "FAQ",
      frequentlyAskedQuestions: "Često postavljana pitanja",
      showFeatureInstructions: "Prikaži {{featureName}} upute",
      minutes: "minuta",
      welcome: "Dobrodošli",
      welcomeBack: "Dobro došao nazad",
      userFallback: "Korisnik",
      defaultGuidelines:
        "Prije pokretanja {{featureName}}, pobrinite se da se nalazite u tihom prostoru bez ometanja sa stabilnom internetskom vezom. Držite kameru uključenu tijekom cijelog testa i mudro upravljajte vremenom jer postoji vremensko ograničenje. Ako naiđete na bilo kakve tehničke probleme, odmah kontaktirajte podršku. Kada završite, pregledajte svoje odgovore prije slanja. Sretno!"
    },
    zoom: {
      textSize: "Veličina teksta:",
      decreaseTextSize: "Smanji veličinu teksta (A-)",
      resetTextSize: "Poništi veličinu teksta (A)",
      increaseTextSize: "Povećaj veličinu teksta (A+)",
      decreaseInterfaceSize: "Smanjite veličinu sučelja",
      resetInterfaceSize: "Resetiraj veličinu sučelja",
      increaseInterfaceSize: "Povećajte veličinu sučelja"
    },
    wrapper: {
      warningTitle: "Upozorenje!",
      stayOnPageMessage:
        "Ostanite na ovoj stranici dok ne ispunite {{featureName}}.",
      iUnderstand: "Razumijem",
      submitTheFeature: "Pošaljite {{featureName}}",
      videoProctoringInterrupted: "Videoproctoring prekinut",
      continuationBlocked:
        "Nastavak ocjenjivanja je blokiran dok se ne uspostavi siguran video nadzor.",
      retryProctoring: "Ponovo pokušaj proctoring"
    },
    progress: {
      proceed: "Nastavite",
      resumeFeature: "Nastavi {{featureName}}",
      timeRemainingMessage:
        "preostali u {{featureName}}. Kliknite ispod da nastavite gdje ste stali.",
      continueOnThisDevice: "Nastaviti na ovom uređaju?",
      switchToThisTab: "Prebaciti se na ovu karticu?",
      continueYourAssessmentHere: "Želite li ovdje nastaviti svoju procjenu?",
      switchHere: "Prebacite se ovdje",
      attemptsUnlimited:
        "Za ovu procjenu imate na raspolaganju neograničen broj pokušaja.",
      attemptsSingle:
        "Imate <strong>1</strong> pokušaja na raspolaganju za ovu procjenu.",
      attemptsMultiple:
        "Imate <strong>{{remainingAttempts}}</strong> od <strong>{{maxAttempts}}</strong> pokušaja dostupnih za ovu procjenu.",
      coolOffAfterAttempt:
        "Nakon svakog pokušaja morat ćete pričekati <strong>{{coolOffTime}}</strong> prije nego započnete sljedeći pokušaj."
    },
    loginWindow: {
      expiredTitle: "Vrijeme prijave je isteklo",
      expiredMessage:
        "Prozor za prijavu za ovaj {{featureName}} sada je zatvoren. Propustili ste dopušteno vrijeme za pristup testu."
    },
    coding: {
      saving: "Spremanje",
      offlineTitle: "Čini se da ste izvan mreže",
      offlineDescription:
        "Promjene se neće sinkronizirati dok se ponovno ne povežete",
      connectionRestored: "Veza je uspostavljena",
      syncingLatest: "Sinkronizacija vaših najnovijih promjena...",
      autoSaveEnabled: "Automatsko spremanje omogućeno",
      runOnlyChecksDescription:
        "samo provjerava vaš kod u odnosu na testne slučajeve.",
      submitEvaluationDescription:
        "svoj kod kako bi bio ocijenjen i kako biste dobili bodove.",
      reset: "Resetiraj",
      run: "Pokreni",
      runTests: "Izvođenje testova",
      submit: "Pošalji",
      submitting: "Podnošenje",
      resetCode: "Poništi kod",
      resetCodeMessage:
        "Jeste li sigurni da želite resetirati? Ovo će ukloniti sav vaš trenutni kod i vratiti početni kod",
      testCases: "Testni slučajevi",
      testCase: "Testni slučaj {{index}}",
      testCasePassed: "Testni slučaj prošao",
      testCaseFailed: "Testni slučaj nije uspio",
      runtimeError: "Runtime Error",
      timeLimitExceeded: "Vremensko ograničenje premašeno",
      timeLimitExceededTitle: "Vremensko ograničenje premašeno",
      timeLimitExceededDescription:
        "Vaš kod se nije izvršio unutar vremenskih ograničenja. Optimizirajte svoj kôd.",
      input: "Ulazni",
      expectedOutput: "Očekivani rezultat",
      yourOutput: "Vaš izlaz",
      hiddenTestCase: "Skriveni ispitni slučaj",
      hiddenTestCaseDescription:
        "Skriveni testni slučajevi koriste se za procjenu može li vaš kod obraditi različite scenarije, uključujući kutne slučajeve",
      explanation: "Obrazloženje",
      hints: "Savjeti"
    },
    subjective: {
      minWordsRequired: "Za slanje odgovora potrebno je najmanje 40 riječi.",
      enterYourAnswer: "Unesite svoj odgovor",
      submitResponse: "Pošaljite odgovor",
      submittingResponse: "Slanje odgovora...",
      resetAnswer: "Resetiraj odgovor",
      resetAnswerMessage:
        "Jeste li sigurni da želite resetirati? Vaš trenutni odgovor bit će trajno uklonjen.",
      retake: "Ponovno snimanje",
      showHint: "Prikaži savjet",
      recording: "SNIMANJE"
    },
    systemCheck: {
      calibrate: "Kalibrirati",
      calibrating: "Kalibracija...",
      accessDenied: "Pristup odbijen",
      cameraPermissionDenied:
        "Dozvola za kameru odbijena. Za nastavak omogućite pristup kameri u postavkama preglednika.",
      errorFetchingDevices: "Pogreška pri dohvaćanju uređaja",
      failedToStartAssessment: "Pokretanje procjene nije uspjelo",
      unableToStartSecureProctoring:
        "Trenutačno nije moguće pokrenuti sigurni nadzor. Molimo pokušajte ponovo.",
      unnamedCamera: "Neimenovana kamera",
      facingCalibrationIssues: "Imate li problema s video kalibracijom?",
      lookAtCenter: "Gledajte u središte ekrana i ostanite mirni.",
      unableToCalibrateTitle:
        "Ne možete kalibrirati svoju kameru za video nadzor?",
      statusMessages: {
        readyForCalibration:
          "Provjerite je li vaše lice jasno vidljivo i centrirano na zaslonu. Kada budete spremni, kliknite 'Kalibriraj' za početak.",
        calibratingInProgress: "Kalibracija u tijeku. Nastavi gledati u ekran.",
        calibratingTimedOut:
          "Kalibracija kamere je istekla. Osvježite preglednik za nastavak.",
        preparingCameraPreview:
          "Priprema streama kamere i praćenja lica za kalibraciju.",
        retryRequired:
          "Postavljanje proctoringa zahtijeva vašu akciju prije nastavka.",
        proctoringUnavailable:
          "Proctoring trenutno nije dostupan i procjena se ne može pokrenuti na siguran način.",
        calibrationCompleted:
          "Kalibracija uspjela! Spremni ste za početak ocjenjivanja.",
        timeoutHelp:
          "Ako i dalje vidite ovu poruku, provjerite postoje li druge kartice/aplikacije pomoću kamere ili vanjskog zatvarača."
      },
      failureReasons: {
        cameraPermissionDenied:
          "Dopuštenje kamere je blokirano. Dopustite pristup i pokušajte ponovno.",
        cameraUnavailable:
          "Kamera nije dostupna. Provjerite odabir uređaja i pokušajte ponovno.",
        facemeshInitFailed:
          "Postavljanje praćenja lica nije uspjelo. Pokušajte ponovno za nastavak.",
        cocoLoadFailed:
          "Proctoring motor nije dostupan. Osvježite i pokušajte ponovno.",
        streamLostReacquireFailed:
          "Oporavak streama kamere nije uspio. Ponovo pokušaj proctoring.",
        calibrationInsufficientData:
          "Uzorci za kalibraciju nisu bili dovoljni. Ponovi kalibraciju.",
        detectionCadenceUnavailable:
          "Konfiguracija vremena nije spremna. Pokušajte ponovo uskoro."
      },
      calibrationInfo: {
        heading:
          "Da biste uspješno kalibrirali svoj video, slijedite ove korake:",
        followUpHeading:
          "Ako se i dalje suočavate s problemom, slijedite ove korake:",
        initialSteps: {
          step1: {
            title: "Osigurajte dobro osvjetljenje",
            description:
              "Sjednite na dobro osvijetljeno mjesto tako da vam lice bude jasno vidljivo. Izbjegavajte jako svjetlo ili prozore iza sebe."
          },
          step2: {
            title: "Okrenite se izravno prema kameri",
            description:
              "Postavite svoje lice u središte kadra i gledajte ravno u kameru tijekom kalibracije."
          },
          step3: {
            title: "Izbjegavajte tamne ili mutne pozadine",
            description: "Provjerite je li pozadina jasna i ne pretamna."
          },
          step4: {
            title: "Provjerite dozvole kamere",
            description:
              "Dopustite svom pregledniku da pristupi web kameri kada se to od vas zatraži."
          },
          step5: {
            title: "Ostanite mirni i gledajte u ekran",
            description:
              "Držite glavu mirno tijekom kalibracije kako biste pomogli sustavu da pravilno detektira vaše lice."
          }
        },
        laterSteps: {
          step1: "Pokušajte osvježiti stranicu i ponovno kalibrirati kameru.",
          step2:
            "Zatvorite druge aplikacije pomoću web kamere (kao što su Zoom ili Teams).",
          step3:
            "Ako se problem nastavi, kontaktirajte {{contactEmail}} sa snimkom zaslona pogreške."
        }
      }
    },
    stepper: {
      termsAndConditions: "Odredbe i uvjeti",
      agreeTerms: "Pročitao sam i slažem se s odredbama i uvjetima.",
      previousStep: "Prethodni korak",
      nextStep: "Sljedeći korak",
      startAssessment: "Započni procjenu",
      resumeAssessment: "Nastavi procjenu",
      mediaCheck: "Provjera medija",
      systemCheck: "Provjera sustava",
      audioCheck: {
        intro:
          "Ovdje možete snimiti kratki video kako biste provjerili rade li vaša kamera i mikrofon kako treba.",
        mediaPermissionDenied:
          "Pristup kameri ili mikrofonu je odbijen. Omogućite dopuštenja u postavkama preglednika.",
        startRecording: "Počni snimanje",
        stopRecording: "Zaustavi snimanje",
        unnamedMicrophone: "Neimenovani mikrofon"
      },
      stepLabel: "KORAK {{step}}",
      personalDetails: "Osobni podaci",
      emailId: "ID e-pošte",
      firstName: "Ime",
      lastName: "Prezime",
      defaultTncStatement:
        "Sudjelovanjem u ovoj procjeni potvrđujete da ispunjavate uvjete prihvatljivosti koje je odredila tvrtka i pristajete na samostalno dovršavanje testa, bez vanjske pomoći. Procjena podliježe video nadzoru, a kamera mora biti uključena tijekom cijele sesije u okruženju bez ometanja. Sav sadržaj i materijali dostavljeni tijekom procjene su povjerljivi i ne smiju se dijeliti, reproducirati ili distribuirati. Suglasni ste da ćete se pridržavati određenog vremenskog ograničenja za procjenu; nepodnošenje prije roka može rezultirati diskvalifikacijom. Tvrtka nije odgovorna za bilo kakve tehničke probleme vezane uz vašu internetsku vezu, softver ili hardver. Osobni podaci prikupljeni tijekom procjene bit će obrađeni samo u svrhu procjene i zapošljavanja, u skladu s politikom privatnosti tvrtke. Svaki pokušaj varanja, plagiranja ili neetičkog ponašanja na drugi način dovest će do trenutne diskvalifikacije. Slanjem odgovora potvrđujete da su oni konačni i da se nakon slanja ne mogu vršiti nikakve izmjene. Tvrtka zadržava pravo izmjene ili ažuriranja ovih uvjeta u bilo kojem trenutku, a sudionici će biti obaviješteni o svim značajnijim promjenama.",
      okay: "U redu"
    },
    access: {
      cancelledTitle: '"{{title}}" je otkazan',
      cancelledDescription:
        "Ova procjena više nije aktivna i ne može joj se pristupiti. Pregledajte svoju nadzornu ploču za druga dodijeljena ili nadolazeća ocjenjivanja.",
      goToHome: "Idi na početnu stranicu",
      refreshPage: "Osvježi stranicu"
    },
    errorPage: {
      goBack: "Natrag",
      raiseRequest: "Pošalji zahtjev",
      retryLogin: "Pokušaj prijavu ponovo",
      contactUs: "Kontaktirajte nas",
      goBackToEvent: "Natrag na događaj",
      launchCourse: "Pokreni tečaj",
      created: "Kreirano",
      starts: "Počinje",
      ends: "Završava",
      untitled: "Bez naslova"
    },
    sidebar: {
      home: "Početna",
      quickAccess: "Brzi pristup",
      questionPaperAuthoring: "Autorstvo upitnika",
      assessmentLibrary: "Biblioteka procjena",
      scheduleInterview: "Zakaži intervju",
      generateQuestions: "Generiraj pitanja",
      roleManagement: "Upravljanje ulogama",
      logout: "Odjava",
      noAccess: "Nema pristupa",
      noAccessWithLabel: "{{label}} (Nema pristupa)",
      noAccessToLink: "Nemate pristup ovoj poveznici",
      expandSidebar: "Proširi bočnu traku",
      collapseSidebar: "Sažmi bočnu traku",
      expand: "Proširi",
      collapse: "Sažmi",
      myPreferences: "Moje postavke"
    },
    timesUp: {
      title: "Vrijeme ocjenjivanja završeno",
      autoSubmittedMessage:
        "Tajmer je istekao. Vaši su odgovori spremljeni i {{featureName}} je automatski poslan."
    },
    resultCard: {
      title: "{{featureName}} Rezultati",
      score: "Postići",
      passPercentage: "Postotak prolaza",
      marksAway:
        "Još {{count}} bodova dijeli vas od certifikacije. Usredotočite se na preporučena područja i pokušajte ponovno.",
      certificationEarned:
        "Premašili ste zahtjeve za certifikaciju i stekli certifikaciju",
      congratulationsOnEarning:
        "Čestitamo na stjecanju certifikata {{featureName}}",
      almostThereTitle: "Bliže ste nego što mislite stjecanju certifikata",
      certificatePassedDescription:
        "Pokazali ste znanje i vještine potrebne za dobivanje ovog certifikata. Odvojite trenutak da proslavite ovo postignuće i podijelite ga sa svojom mrežom",
      certificateFailDescription:
        "Ovaj pokušaj istaknuo je mogućnosti za jačanje vaših vještina. Pregledajte preporučena područja i vratite se s povjerenjem",
      congratsImageAlt: "Čestitke slika",
      almostThereImageAlt: "Još malo pa slika"
    },
    sectionCard: {
      section: "Odjeljak",
      startSection: "Početak odjeljka",
      continueSection: "Nastavi odjeljak",
      completed: "Završeno",
      viewSection: "Pogledajte odjeljak",
      totalQuestions: "Ukupno pitanja:",
      sectionNotFound: "Odjeljak nije pronađen.",
      total: "Ukupno",
      flagged: "Označeno"
    },
    sectionSummary: {
      totalQuestions: "Ukupno pitanja",
      completedQuestions: "Završena pitanja",
      flaggedQuestions: "Označena pitanja",
      unattemptedQuestions: "Pitanja bez pokušaja",
      codingQuestions: "Pitanja o kodiranju:",
      objectiveQuestions: "Objektivna pitanja:",
      goToSections: "Idi na odjeljke",
      lowWordCountWarning:
        "Vaš odgovor na pitanje, {{questionTitle}} kraći je od 40 riječi. Ako se vratite na popis odjeljaka, ovaj će odgovor biti odbačen.",
      videoNotSubmittedWarning:
        "Vaš snimljeni video za pitanje, {{questionTitle}} nije poslan. Ako se vratite na popis odjeljaka, ovaj će odgovor biti odbačen."
    },
    objective: {
      questionCounter: "Pitanje",
      marks: "Oznake:",
      explanation: "Obrazloženje",
      hints: "Savjeti",
      reset: "Resetiraj",
      flag: "Zastava",
      unflag: "Ukloni zastavicu",
      previous: "Prethodno",
      saveAndNext: "Spremi & Dalje",
      saveAndViewSummary: "Spremite i pogledajte sažetak odjeljka",
      next: "Sljedeći",
      viewSectionSummary: "Pogledajte sažetak odjeljka",
      hideExplanation: "Sakrij objašnjenje",
      showExplanation: "Prikaži objašnjenje",
      hintWaitTooltip:
        "Morate pričekati prije nego što vidite još jedan savjet",
      noHintsPendingTooltip: "Nema savjeta na čekanju",
      selectOptionForExplanation:
        "Odaberite opciju za pregled objašnjenja odabrane opcije"
    },
    tour: {
      shared: {
        timer:
          "Ovaj mjerač vremena prikazuje preostalo vrijeme za vašu procjenu. Pažljivo ga pratite kako biste bili sigurni da ste ispunili sve odjeljke unutar dodijeljenog vremena.",
        submit:
          "Nakon što završite sve dijelove ocjenjivanja, možete predati svoj rad klikom na gumb 'Pošalji ocjenu'. Ova radnja dovršava vaše odgovore i više nećete moći unositi promjene nakon što ih pošaljete. Provjerite jeste li pregledali sve svoje odgovore prije nego što nastavite s predajom."
      },
      dashboard: {
        legend:
          "Legenda statusa odjeljka pomaže vam razumjeti vaš napredak tijekom procjene. Koristi jasne indikatore da pokaže je li odjeljak još nije započet, je li trenutno u tijeku ili je dovršen. To vam omogućuje da brzo procijenite koji dijelovi još zahtijevaju vašu pažnju i učinkovito upravljate svojim vremenom.",
        sectionCard:
          "Kartica odjeljka pruža detaljan pregled svakog odjeljka ocjenjivanja. Prikazuje naslov odjeljka, njegov trenutni status i ključne informacije o pitanjima unutar odjeljka. To uključuje ukupan broj pitanja, broj označenih pitanja i broj pitanja koja su dovršena. Kartica odjeljka pomaže vam u praćenju vašeg napretka i prepoznavanju područja kojima je možda potrebno više pažnje."
      },
      coding: {
        titles:
          "Na vrhu stranice pronaći ćete jasan prikaz naslova procjene i naslova odjeljka. To vam pomaže da pratite svoj trenutni zadatak i osigurava da ste svjesni određenog odjeljka na kojem radite. Pogledajte ove naslove kako biste ostali orijentirani dok se krećete kroz pitanja.",
        sectionsButton:
          "Ovaj vam gumb omogućuje laku navigaciju natrag na nadzornu ploču odjeljaka. Koristite ga za povratak na glavni pregled vaše procjene, gdje možete vidjeti i upravljati napretkom svih odjeljaka. Omogućuje brz način za ponovnu procjenu vašeg ukupnog napretka bez gubitka bilo čega od vašeg trenutnog rada.",
        sidebar:
          "Bočna traka pruža pregled svih pitanja unutar trenutnog odjeljka koji pokušavate postaviti. Omogućuje vam brzu navigaciju između pitanja jednostavnim odabirom relevantnog bloka. Svaki blok pitanja označen je bojama na temelju statusa, što olakšava praćenje vašeg napretka i prelazak na određena pitanja po potrebi.",
        questionCard:
          "Ova kartica sadrži pitanje na kojem trenutno radite, prikazuje cijeli upit i sve relevantne upute ili zahtjeve za unos. Osmišljen je kako bi vam pružio jasan pregled zadatka koji je pred vama, sa svim potrebnim informacijama za nastavak. Također ćete pronaći gumb za označavanje pitanja za kasniji pregled, što vam omogućuje da ga lako ponovno pregledate ako je potrebno. Dodatno, postoje navigacijski gumbi koji vam omogućuju prijelaz na sljedeće ili prethodno pitanje bez vraćanja na bočnu traku, osiguravajući glatko i učinkovito napredovanje kroz procjenu.",
        editor:
          "Uređivač koda mjesto je gdje ćete pisati i modificirati svoja rješenja. Možete se prebacivati ​​između različitih programskih jezika kako biste zadovoljili zahtjeve svakog pitanja. Osim toga, imate mogućnost prilagoditi temu uređivača za ugodnije iskustvo kodiranja. Ako želite više prostora na zaslonu, uređivač se može proširiti na punu širinu, dajući vam veće područje za rad. Ove su značajke osmišljene kako bi pružile fleksibilno okruženje prilagođeno korisniku dok obavljate svoje zadatke kodiranja."
      }
    },
    toast: {
      proctoringViolationDetected: "Otkriveno kršenje proctoringa",
      messages: {
        forbiddenObjectDetected: "Otkriven zabranjeni predmet",
        noFaceDetected: "Nije otkriveno lice",
        multipleFacesDetected: "Otkriveno je više lica",
        lookingAwayFromScreen: "Skretanje pogleda s ekrana",
        notLookingAtScreen: "Ne gledajući u ekran",
        faceNotOrientedCorrectly: "Lice nije ispravno usmjereno",
        eyesNotFullyOpen: "Oči nisu potpuno otvorene",
        copyNotAllowed: "Kopiranje nije dopušteno",
        cutRestricted: "Rezanje je ograničeno u načinu nadzora",
        pasteNotAllowed: "Lijepljenje nije dopušteno",
        contextMenuNotAllowed: "Otvaranje kontekstnog izbornika nije dopušteno"
      }
    },
    whatsNext: {
      heading: "Što je sljedeće?",
      attemptsRemaining: "preostalih pokušaja",
      passed: {
        shareLinkedInTitle: "Podijelite na LinkedInu",
        shareLinkedInSubtitle:
          "Proslavite svoje postignuće sa svojom profesionalnom mrežom.",
        viewCertificateTitle: "Pregledajte certifikat",
        viewCertificateSubtitle:
          "Preuzmite ili pristupite svom certifikatu bilo kada.",
        shareGloTitle: "Podijelite iskustvo",
        shareGloSubtitle:
          "Inspirirajte kolege internim objavljivanjem svojih postignuća."
      },
      failed: {
        reviewLearningResourcesTitle: "Pregledajte resurse za učenje",
        reviewLearningResourcesSubtitle:
          "Ojačajte vještinu koja zahtijeva pažnju.",
        retakeAssessmentTitle: "Ponovno riješite procjenu",
        retakeAssessmentSubtitle:
          "Pokažite svoj napredak i ažurirano razumijevanje."
      },
      modal: {
        title: "Podijelite postignuće",
        linkedInPostLabel: "Podijelite na LinkedInu kao objavu",
        linkedInProfileLabel: "Dodajte kao certifikat na LinkedIn profil",
        gloLabel: "Podijeli na Glo",
        comingSoon: "Dolazi uskoro",
        infoMessage: "Za dijeljenje morate biti prijavljeni na platformu."
      }
    },
    time: {
      hour_one: "{{count}} sat",
      hour_other: "{{count}} sati",
      minute_one: "{{count}} minuta",
      minute_other: "{{count}} minuta",
      hourShort: "h",
      minuteShort: "min",
      secondShort: "s"
    },
    accessScreens: {
      attemptResultProcessing: {
        alt: "{{featureName}} rezultati su u obradi",
        title: "Vaši rezultati se obrađuju",
        description:
          "Još uvijek pregledavamo vašu {{featureName}}. Provjerite uskoro!"
      },
      coolOffPeriod: {
        alt: "Razdoblje hlađenja",
        title: "Sljedeći pokušaj uskoro dostupan",
        completedAttempt: "Već ste završili pokušaj za ovo",
        nextAttemptIntro: ". Vaš sljedeći pokušaj bit će dostupan za"
      },
      maxAttemptExceeded: {
        alt: "Dostignut je najveći broj pokušaja",
        title: "Dosegnut je maksimalan broj pokušaja",
        description:
          "Iskoristili ste sve dostupne pokušaje za ovaj {{featureName}}. Nema daljnjih pokušaja."
      },
      scheduleNotStarted: {
        alt: "Raspored nije pokrenut",
        title: "{{featureName}} Još nije počelo",
        scheduledPrefix: "The",
        scheduledOn: "početak je zakazan za",
        checkBack:
          "Provjerite ponovno u {{time}} ili osvježite kada vrijeme počne."
      },
      scheduleTimeCompleted: {
        alt: "Raspored je završen",
        title: "{{featureName}} Prozor zatvoren",
        description:
          "Zakazano vrijeme za ovu {{featureName}} je prošlo. Više ne možete započeti ili poslati pokušaj."
      }
    },
    attemptDetails: {
      allAttempts: "Svi pokušaji",
      headers: {
        attempt: "Pokušaj",
        attemptedOn: "Pokušano",
        percentage: "Postotak"
      },
      viewAllAttempts: "Prikaži sve pokušaje"
    },
    survey: {
      questions: {
        q1: "Na ljestvici od 1 do 5, koliko su vam jasna bila pitanja {{featureName}}?",
        q2: "Osjećao sam se dovoljno pripremljenim za teme o kojima se raspravljalo u {{featureName}}",
        q3: "Platforma korištena za {{featureName}} bila je laka za korištenje i funkcionalna",
        q4: "Vjerujem da su moji odgovori učinkovito pokazali moje vještine i znanje"
      },
      stronglyDisagree: "Uopće se ne slažem",
      stronglyAgree: "U potpunosti se slažem",
      submitFeedback: "Pošaljite povratne informacije"
    },
    cameraPreview: {
      loadingAlt: "Učitavanje pregleda kamere",
      delayedMessage:
        "Kalibracija traje duže od očekivanog zbog spore mreže. Pričekajte ili pokušajte osvježiti stranicu."
    },
    proctoring: {
      engineLoadFailedStatus: "Proctoring motor se nije uspio učitati",
      runtimeErrors: {
        cameraPermissionDenied:
          "Pristup kameri blokiraju postavke dopuštenja preglednika.",
        cameraUnavailable:
          "Kamera nije dostupna ili je trenutno koristi druga aplikacija.",
        unableToLoadModel:
          "Nije moguće učitati model otkrivanja objekta nadziratelja.",
        webglRecoveryFailed:
          "Oporavak WebGL-a nije uspio tijekom vraćanja otkrivanja objekta."
      },
      logs: {
        engineLoadFailed: "ProctoringEngine nije uspio učitati:",
        videoPlayRejected: "Video play() odbijen:",
        cameraTrackEnded:
          "Praćenje kamere je završeno - pokušaj ponovnog snimanja",
        cameraReacquired: "Kamera ponovno nabavljena u pokušaju {{attempt}}",
        cameraReacquireAttemptFailed:
          "Pokušaj ponovnog preuzimanja kamere {{attempt}} nije uspio:",
        cameraReacquireFailedAll:
          "Ponovna akvizicija kamere nije uspjela nakon svih pokušaja - prijavljivanje kamere Disconnected svaki ciklus",
        uploadFailedQueued:
          "Proctoring prijenos nije uspio nakon {{attempts}} pokušaja, čekanje za ponovni pokušaj:",
        uploadAttemptFailedRetrying:
          "Proctoring pokušaj prijenosa {{attempt}} nije uspio, ponovni pokušaj...",
        drainedQueuedViolation:
          "Isušeno kršenje čekanja: {{violationType}} (preostalo {{remaining}})",
        queueDrainFailed:
          "Ispuštanje reda čekanja nije uspjelo, pokušat ćemo ponovno sljedeći ciklus:",
        cocoLoadFailed: "Učitavanje COCO-SSD-a nije uspjelo:",
        faceProcessingError: "Pogreška obrade lica:",
        errorProcessingFrame: "Pogreška obrade okvira:",
        faceMeshInitError: "Pogreška inicijalizacije Face Mesha:"
      }
    }
  }
} as const;

export default hr;
